module.exports = __webpack_public_path__ + "static/media/covid-act-now-logo-url-light.69accdec.svg";